import React, { useContext } from "react";
import { FaCar, FaTrafficLight, FaMobileAlt, FaUserSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./safe.jpg";

const Road: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/road-safety');
    } else {
      navigate('/login', { state: { from: '/booking/road-safety' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Transport</span>
          <h1 className="hero-title">Defensive Driving</h1>
          <p className="hero-subtitle">
            Safety doesn't stop at the factory gate. Principles of road safety,
            vehicle maintenance, and responsible driving behavior.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Defensive Driving</h2>
              <p className="article-text">
                Don't just drive; anticipate. Assume other drivers will make mistakes.
                Keep a safe following distance (2-second rule, 4 seconds in rain).
                Always scan 12-15 seconds ahead to react early to hazards.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The Fatal Distraction</h2>
              <p className="article-text">
                <FaMobileAlt style={{ marginBottom: '-2px', marginRight: '5px' }} />
                <strong>Texting while driving</strong> increases crash risk by 23x.
                It's known as "Visual, Manual, and Cognitive" distraction simultaneously.
                Pull over if you need to call. No message is worth a life.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Vehicle Health (POWDER)</h2>
              <p className="article-text">
                Check before every long trip:
                <ul style={{ paddingLeft: '20px', color: '#ccc', marginTop: '10px', lineHeight: '1.8' }}>
                  <li><strong>P</strong>etrol/Fuel level.</li>
                  <li><strong>O</strong>il and fluids.</li>
                  <li><strong>W</strong>ater (Coolant/Washers).</li>
                  <li><strong>D</strong>amage to body/glass.</li>
                  <li><strong>E</strong>lectrics (Lights/Indicators).</li>
                  <li><strong>R</strong>ubber (Tyres/Wipers).</li>
                </ul>
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Driver's Code</h4>
              <ul className="key-list">
                <li><FaTrafficLight className="check-icon" /> Obey Speed Limits</li>
                <li><FaCar className="check-icon" /> Wear Seatbelts</li>
                <li><FaUserSlash className="check-icon" /> Zero Alcohol Tolerance</li>
                <li><FaMobileAlt className="check-icon" /> No Phones</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Drive Safe</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Arrive alive. Professional driver training available.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Road;
